import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFeaturesForAccount } from 'util/api/flipper';

export const fetchFlipperFeatures = createAsyncThunk(
  'flipper/fetch',
  async (accountId, thunkAPI) => {
    return await getFeaturesForAccount(accountId);
  },
);

const slice = createSlice({
  name: 'flipper',
  initialState: {
    features: [],
    flipperId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFlipperFeatures.rejected, (_state, action) => {
      console.error('Error running request', action);
    });
    builder.addCase(fetchFlipperFeatures.fulfilled, (state, action) => {
      state.features = action.payload.features;
      state.flipperId = action.payload.flipper_id;
    });
  },
});

export default slice;
